import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CART_RULE_EDITOR_CLASS_NAME = 'CartRuleEditor';
export const CART_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type CartRuleEditorClassSlot =
	(typeof CART_RULE_EDITOR_CLASS_SLOTS)[number];

export interface CartRuleEditorClasses {
	root: string;
}

export type CartRuleEditorClassKey = keyof CartRuleEditorClasses;

export const getCartRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(CART_RULE_EDITOR_CLASS_NAME, slot);

export const cartRuleEditorClasses: CartRuleEditorClasses =
	generateUtilityClasses(CART_RULE_EDITOR_CLASS_NAME, ['root']);

export default cartRuleEditorClasses;
